/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Compliance_Disabled_DescInputs */



/**
* | output |
* | --- |
* | "Compliance guardrails are turned off and no longer monitoring requests" |
*
* @param {Audit_Details_Compliance_Disabled_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_compliance_disabled_desc = /** @type {((inputs?: Audit_Details_Compliance_Disabled_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Compliance_Disabled_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance-Leitplanken sind deaktiviert und überwachen keine Anfragen mehr")
	return /** @type {LocalizedString} */ ("Compliance guardrails are turned off and no longer monitoring requests")
});